import { LOCALE } from '@/util/i18n/locale';
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('platforms', ['platforms']),
  },
  created() {
    if (!this.platforms || !this.platforms.length) {
      this.getPlatforms();
    }
  },
  methods: {
    ...mapActions('platforms', ['getPlatforms']),
    getPlatformName(id) {
      const el = this.platforms.find((platform) => platform.id === id);
      return el ? (this.$i18n.locale === LOCALE.FR_CA ? el.nameFr : el.nameEn) : '';
    },
    getOpportunitySourceName(source) {
      if (!source) return this.$t('page.opportunities.new.sources.unknown');
      const key = `page.opportunities.new.sources.${source}`;
      if (this.$te(key)) return this.$t(key);
      return this.getPlatformName(source) || this.$t('page.opportunities.new.sources.unknown');
    },
  },
};
